import React from "react";

const ClickToCall = ({ phone, children }) => {
  return <a href={`tel:${phone}`} style={{ textDecoration: 'none', color: 'inherit' }}>{children}</a>;
};
export default ClickToCall;
